import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { StateDistric } from "../../../api/EnquiryService";
import {
  Createstaff,
  fetchstaff,
  Staffupdate,
  getstaffwithid,
} from "../../../api/FacultyService";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastMain,SweetAlertShow } from "../../master/Master";

const EditStaff = () => {
  const [loading, setLoading] = React.useState(false);
  const [allStates, setAllStates] = React.useState([]);
  const [allDistricts, setAllDistricts] = React.useState([]);
  const [filteredDistricts, setFilteredDistricts] = React.useState([]);
  const [selectedStateId, setSelectedStateId] = React.useState("");
  const [Result, setResult] = React.useState("");
  const [error, setError] = useState("");
  const [staff, setStaff] = useState('')
  const navigate = useNavigate();
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const id = queryParams.get("id")
  const { id } = useParams();
  console.log("param id ", { id });
  const [Teachers, setTeachers] = React.useState("");


  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateDistric();
      if (response.data.status) {
        setAllStates(response.data.data.states);
        setAllDistricts(response.data.data.districts);
      } else {
        ToastMain.fire({
          icon: "info",
          title: response?.data?.message || "Something Want Wrong!",
        }).then(() => {
          setLoading(false);
        });
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // }).then(() => {
      //   setLoading(false);
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getState();
  }, []);

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedStateId(stateId);

    // Filter districts by state_id
    const filtered = allDistricts.filter(
      (district) => district.state_id == stateId
    );
    setFilteredDistricts(filtered);
  };

  const staffFatch = async () => {
    try {
      const response = await getstaffwithid(id); // ✅ id from useParams
      // console.log("Raw API Response:", response);

      if (response?.data?.status) {
        setTeachers(response?.data?.data)

      } else {
        
         
        SweetAlertShow('info','Warning',response?.data?.message)
     
      }
    } catch (error) {
     

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message  ?? error?.message)
      
    }finally{
      setLoading(false);

    }
  };

  useEffect(() => {
    staffFatch(); // ✅ Don't pass id
  }, [id]); //

  const handlestaffEdit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());

      const response = await Staffupdate(data);
      console.log(response);
      if (response.data) {
        ToastMain.fire({
          icon: "success",
          title: "updated successfully!",
        });

        navigate(`/teachers/view/${Teachers.id}`); // ✅ navigate with dynamic ID
      } else {
       

        SweetAlertShow('info','Warning', response?.data?.message )
      }
    } catch (error) {
    

      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
      
    }finally{
      setLoading(false);

    }
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="container-fluid mt-4">
            <div className="card p-4 shadow-sm rounded-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="text-primary fw-bold">Edit Faculty</h3>
                <div>{/* form goes here */}</div>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => navigate(-1)} // 👈 function ke andar
                >
                  Go Back
                </button>
              </div>
              <hr />

              <form onSubmit={handlestaffEdit}>
                {/* Basic Info */}
                <div className="p-3 rounded">
                  <h5 className="text-primary fw-bold">Basic Details </h5>
                  <div className="row g-3">
                    {/* <input type="text" name="id" value={Teachers?.id} className="form-control" placeholder="Staff ID" required /> */}

                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input type="hidden" name="id" value={id} />
                      <input
                        type="text"
                        name="staff_id"
                        className="form-control"
                        placeholder="Staff ID"
                        value={Teachers?.staff_id} // ✅ controlled value
                        // onChange={(e) =>
                        //   setTeachers({ ...Teachers, staff_id: e.target.value })
                        // }
                        required
                      />

                      <label>
                        Staff ID <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="staff_name"
                        className="form-control input-capitalize"
                        placeholder="Full Name"
                        defaultValue={Teachers?.name}
                        required
                      />
                      <label>
                        Full Name <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="Number"
                        defaultValue={Teachers?.phone}
                        name="mobile"
                        className="form-control"
                        maxLength="10"
                        placeholder="Mobile"
                        required
                      />
                      <label>
                        Mobile <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.secondary_phone}
                        name="secondary_mobile"
                        className="form-control"
                        maxLength="10"
                        placeholder="Alternate Number"

                      />
                      <label>
                        Alternate Number
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        className="form-control input-uppercase"
                        name="father_name"
                        placeholder="Father's Name"
                        defaultValue={Teachers?.father_name}
                       
                      />
                      <label>
                        Father's Name 
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        defaultValue={Teachers?.email}
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <label>Email</label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <select name="gender" className="form-select" required>
                        <option name="gender" defaultValue={Teachers?.gender}>
                          {Teachers?.gender || "Select gender"}
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                      <label>
                        Select Gender<span className="text-danger">*</span>
                      </label>
                    </div>

                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="date"
                        defaultValue={Teachers?.dob}
                        name="dob"
                        className="form-control"
                      />
                      <label>Date Of Birth</label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="Number"
                        defaultValue={Teachers?.aadhar}
                        name="aadhar"
                        className="form-control"
                        maxLength="10"
                        placeholder="Aadhaar Number"

                      />
                      <label>
                        Aadhaar Number 
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.referred_by}
                        name="'referred_by"
                        className="form-control"
                        placeholder="Referred By"
                      />
                      <label>
                        Referred By <span className="text-danger"></span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="Date"
                        name="join_date"
                        className="form-control"
                        placeholder="Join Dete"

                      />
                      <label>
                        Joining Details <span className="text-danger">*</span>
                      </label>
                    </div>
                  </div>
                </div>

                <hr />

                {/* Additional Info */}
                <hr />

                {/* Address Info */}
                <div className="p-3 rounded">
                  <h5 className="text-primary fw-bold">
                    Qualification Details
                  </h5>
                  <div className="row g-3 mt-1">
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.education}
                        name="education"
                        className="form-control"
                        placeholder="Education"

                      />
                      <label>
                        Education
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.school}
                        name="school_name"
                        className="form-control input-uppercase"
                        placeholder="School Name"
                      />
                      <label>School Name</label>
                    </div>
                  </div>
                </div>

                <hr />

                {/* Address Info */}
                <div className="p-3 rounded">
                  <h5 className="text-primary fw-bold">Address </h5>
                  <div className="row g-3 mt-1">
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.village}
                        name="village"
                        className="form-control input-uppercase"
                        placeholder="Village"
                        
                      />
                      <label>
                        Village 
                      </label>
                    </div>
                    <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <select
                        className="form-select"
                        name="state"
                        value={selectedStateId}
                        onChange={handleStateChange}
                        required
                      >
                        {/* <option value={Teachers?.state?.id}>
                          {Teachers?.state?.name}
                        </option> */}

                        {allStates?.map((state) => (
                          <option key={state.id} value={state.id} selected={Teachers?.state == state?.id&&true}>
                            {state?.name}
                          </option>
                        ))}
                      </select>
                      <label>State <span className="text-danger">*</span> </label>
                    </div>
                    <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <select className="form-select" name="district" required>
                        <option
                          defaultValue={Teachers?.district}
                          name="district"
                        >
                          {Teachers?.district}
                        </option>
                        {filteredDistricts?.map((district) => (
                          <option key={district?.id} value={district?.id}>
                            {district?.name}
                          </option>
                        ))}
                      </select>
                      <label>
                        District <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.zipcode}
                        name="zipcode"
                        className="form-control"
                        placeholder="Pincode"
                      />
                      <label>Pincode</label>
                    </div>
                    {/* <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <textarea
                        name="address"
                        defaultValue={Teachers?.address}
                        className="form-control"
                        placeholder="Full Address"
                        style={{ height: "80px" }}
                      />
                      <label>Full Address</label>
                    </div> */}
                  </div>
                </div>

                {/* Additional Details */}
                <div className="p-3 rounded">
                  <h5 className="text-primary fw-bold">Additional Details</h5>
                  <div className="row g-3 mt-1">
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <select name="user_type" className="form-select" required>

                        <option value="">Select Type</option>
                        <option value="Teacher" selected={Teachers?.type_id === 'Teacher' && true}>Teacher</option>
                        <option value="Counselor" selected={Teachers?.type_id === 'Counselor' && true}>Counselor</option>
                        <option value="Accountant" selected={Teachers?.type_id === 'Accountant' && true}>Accountant</option>
                        <option value="Staff" selected={Teachers?.type_id === 'Staff' && true}>Staff</option>
                      </select>
                      <label>
                        Select Type*<span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="Number"
                        defaultValue={Teachers?.present_salary}
                        name="salary"
                        className="form-control"
                        placeholder="Salary (Per Month)*"
                        required
                      />
                      <label>Salary (Per Month) <span className="text-danger">*</span> </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                      <input
                        type="text"
                        defaultValue={Teachers?.remark}
                        name="remark"
                        className="form-control input-uppercase"
                        placeholder="Remark"
                      />
                      <label>Remark</label>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate(`/teachers/view/${Teachers.id}`)} // 👈 Replace with your target route
                  >
                    Cancel
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </div>
  );
};

export default EditStaff;
